import { format, parseISO } from 'date-fns'
import WithdrawRequestWarning from './withdrawRequestWarning'
import AdxButton from 'components/custom/AdxButton'

const RequestButtonOptions = ({ requestStatus, updatedAt, handleWithdraw }) => {
  switch (requestStatus) {
    case 17:
      return <WithdrawRequestWarning handleWithdraw={handleWithdraw} />
    case 18:
      return null
    case 10:
      return <WithdrawRequestWarning handleWithdraw={handleWithdraw} />
    case 12:
      return <WithdrawRequestWarning handleWithdraw={handleWithdraw} />
    case 13:
      return <WithdrawRequestWarning handleWithdraw={handleWithdraw} />
    case 14:
      return <WithdrawRequestWarning handleWithdraw={handleWithdraw} />
    case 15:
      return <WithdrawRequestWarning handleWithdraw={handleWithdraw} />
    case 11:
      return null
    case 16:
      return (
        <AdxButton
          variant={'ghost'}
          fullWidth
          disabled
          sx={{
            backgroundColor: 'gray-background.main',
            color: 'light-gray-text.main',
            '&:disabled': {
              color: 'light-gray-text.main',
            },
          }}
        >
          Withdrawn on {format(parseISO(updatedAt), `dd/MM/yyyy, hh:mmaa`)}
        </AdxButton>
      )

    default:
      return null
  }
}

export default RequestButtonOptions
